module.exports = __webpack_public_path__ + "img/emotion-hate.88e5ff6a.svg";